module.exports = __webpack_public_path__ + "static/media/pedido-entregado-green.c5b316e6.svg";